import React from "react";
import { usePayment } from "../hooks";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import StackList from "./stackList";

const PaymentSummary: React.FC = () => {
  const { amount, name, selectedMethod, phoneNumber, notificationNumber } =
    usePayment();
  const { t } = useTranslation();

  const listData = [
    {
      title: t("payment.form.amount"),
      value: `${parseInt(amount).toLocaleString()} FCFA`,
    },
    {
      title: t("payment.form.customer_name"),
      value: name,
    },
    {
      title: t("payment.form.customer_code"),
      value: phoneNumber || "-",
    },
    {
      title: t("payment.payment_method"),
      value: selectedMethod?.name || "-",
    },
    {
      title: t("payment.paymentForSearch.notification_phone_label"),
      value: notificationNumber || "-",
    },
    // {
    //   title: t("payment.form.total_amount"),
    //   value: (
    //     <Typography color="red" variant="h5">
    //       {parseInt(amount).toLocaleString()} FCFA
    //     </Typography>
    //   ),
    // },
  ];

  if (!selectedMethod) return null;

  return (
    <Box>
      <Typography sx={{ textAlign: "center", marginBottom: 2 }} variant="h5">
        {t("payment.details")}
      </Typography>

      <Box
        className="space-y-4"
        sx={{
          backgroundColor: "#F5F5F5",
          padding: 2,
          marginBottom: 5,
        }}
      >
        <Box>
          <StackList spacing={2} list={listData} margin={2} />
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentSummary;
